/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListEaiControlledDeviceIdsRequest = {
  agentId: string;
};

/** @internal */
export const ListEaiControlledDeviceIdsRequest$inboundSchema: z.ZodType<
  ListEaiControlledDeviceIdsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type ListEaiControlledDeviceIdsRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const ListEaiControlledDeviceIdsRequest$outboundSchema: z.ZodType<
  ListEaiControlledDeviceIdsRequest$Outbound,
  z.ZodTypeDef,
  ListEaiControlledDeviceIdsRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listEaiControlledDeviceIdsRequestToJSON(
  listEaiControlledDeviceIdsRequest: ListEaiControlledDeviceIdsRequest,
): string {
  return JSON.stringify(
    ListEaiControlledDeviceIdsRequest$outboundSchema.parse(
      listEaiControlledDeviceIdsRequest,
    ),
  );
}
export function listEaiControlledDeviceIdsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEaiControlledDeviceIdsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEaiControlledDeviceIdsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEaiControlledDeviceIdsRequest' from JSON`,
  );
}
